/*
 * Public API Surface of pepperi-lib/core/common/pipes
 */
export * from './common-pipes';
